// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ee2e9a56","921":"1778358c"}[chunkId] + ".chunk.js";
};